<template>
	<div>
		<div class="pre-end" :class="{ active: !report, ['players-' + this.$store.state.players.length]: true }">
			<Background color="yellow" :rotating="true" />

			<div class="prop player-1">
				<Prop color="orange" />
			</div>
			<div class="prop player-2">
				<Prop color="pink" />
			</div>
		</div>

		<div class="end" :class="{ active: report }">
			<Background :color="winner.color" />
			<MainColumn class="center">
				<div class="scores" :class="{ ['players-' + $store.state.players.length]: true }">
					<div class="player" :class="{ ['player-' + (index + 1)]: true, winner: winner.index == index }" v-for="(player, index) in $store.state.players" :key="index">
						<div class="prop">
							<Prop :color="player.color" />
						</div>
						<div class="score">
							<div class="value">{{ player["score"] }}</div>
							<div class="team-name">{{ player.name }}</div>
						</div>
						<div class="guessed-words">{{ player["guessedWords"] }}/{{ settings.wordsPerGame }}</div>
					</div>
				</div>

				<div class="report">
					<div v-if="$store.state.players.length == 1" class="stars">
						<div class="star" :class="{ active: star1 }"></div>
						<div class="star" :class="{ active: star2 }"></div>
						<div class="star" :class="{ active: star3 }"></div>
					</div>

					<div v-if="$store.state.players.length > 1" class="the-winner-is">
						Ha vinto la squadra <span :class="'color-' + winner.color">{{ winner.name }}</span>
					</div>

					<div :class="{ win: word.status, lost: !word.status }" class="single-result" v-for="(word, index) in wordsData" :key="index">
						<div class="word">
							<span :key="i" v-for="(letter, i) in word.word">{{ letter }}</span>
						</div>
						<div class="type">
							{{ word.type }}
						</div>
						<div class="meaning">
							{{ word.meaning }}
						</div>
					</div>
					<div class="buttons">
						<div @click="$router.push('/')">Torna al menù iniziale</div>
					</div>
				</div>
			</MainColumn>
		</div>
	</div>
</template>

<script>
import Background from "@/components/Background.vue";
import MainColumn from "@/components/MainColumn.vue";
import Prop from "@/components/Prop.vue";

export default {
	components: { Background, MainColumn, Prop },
	props: ["settings"],
	data() {
		return {
			star1: false,
			star2: false,
			star3: false,
			winner: false,
			wordsData: [],
			report: false,
		};
	},
	mounted() {
		this.playAudio("urra", true);
		setTimeout(() => {
			this.report = true;
			if (this.$store.state.players.length == 1) {
				let scoreIn10 = Math.floor((this.$store.state.players[0].guessedWords / this.settings.wordsPerGame) * 10);
				let timeAnimation = 1300;
				if (scoreIn10 > 1) {
					setTimeout(() => {
						this.star1 = true;
						this.playAudio("ding1");

						if (scoreIn10 > 4) {
							setTimeout(() => {
								this.star2 = true;
								this.playAudio("ding2");

								if (scoreIn10 == 10) {
									setTimeout(() => {
										this.star3 = true;
										this.playAudio("ding3");
									}, timeAnimation / 3);
								}
							}, timeAnimation / 3);
						}
					}, timeAnimation / 3);
				}
			}
		}, 5000);
		setTimeout(() => {
			this.playAudio("endgame");
		}, 10000);

		let maxScore = 0;
		this.$store.state.players.forEach((player, index) => {
			if (player.score > maxScore) {
				this.winner = player;
				this.winner["index"] = index;
				maxScore = player.score;
			}
			// merge 2 array
			this.wordsData = this.wordsData.concat(player.wordsData);
		});
	},
};
</script>
<style lang="scss">
.stars {
	justify-content: center;
	display: flex;
	margin-bottom: 2rem;
	.star {
		display: inline-block;
		position: relative;
		width: px(130);
		height: px(130);
		background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='139.962' height='129.196' viewBox='0 0 139.962 129.196'%3E%3Cdefs%3E%3ClinearGradient id='linear-gradient' x1='0.5' y1='0.5' x2='0.5' y2='1' gradientUnits='objectBoundingBox'%3E%3Cstop offset='0' stop-color='%23bababa'/%3E%3Cstop offset='1' stop-color='%23bababa'/%3E%3C/linearGradient%3E%3C/defs%3E%3Cpath id='Poligono_4' data-name='Poligono 4' d='M59.18,22.314a12,12,0,0,1,21.6,0l7.342,15.167a12,12,0,0,0,9.348,6.683l16.514,2.015a12,12,0,0,1,6.625,20.786l-11.655,10.61a12,12,0,0,0-3.7,11.2l3.074,15.59a12,12,0,0,1-17.429,12.905l-15.269-8.159a12,12,0,0,0-11.311,0l-15.269,8.159A12,12,0,0,1,31.628,104.36L34.7,88.77a12,12,0,0,0-3.7-11.2L19.352,66.965a12,12,0,0,1,6.625-20.786L42.49,44.164a12,12,0,0,0,9.348-6.683Z' transform='translate(139.962 129.196) rotate(180)' fill='url(%23linear-gradient)'/%3E%3C/svg%3E%0A");
		background-size: px(130);
		background-repeat: no-repeat;
		background-position: top;
		transform: rotate(180deg);
		background-size: px(150);

		&:before {
			content: "";
			transition: all 1s;
			background-repeat: no-repeat;
			background-position: top;
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			width: 100%;
			height: 0;
			background-size: px(150);
			background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='139.962' height='129.196' viewBox='0 0 139.962 129.196'%3E%3Cdefs%3E%3ClinearGradient id='linear-gradient' x1='0.5' y1='0.5' x2='0.5' y2='1' gradientUnits='objectBoundingBox'%3E%3Cstop offset='0' stop-color='%23ffe500'/%3E%3Cstop offset='1' stop-color='%23ff9a00'/%3E%3C/linearGradient%3E%3C/defs%3E%3Cpath id='Poligono_5' data-name='Poligono 5' d='M59.18,22.314a12,12,0,0,1,21.6,0l7.342,15.167a12,12,0,0,0,9.348,6.683l16.514,2.015a12,12,0,0,1,6.625,20.786l-11.655,10.61a12,12,0,0,0-3.7,11.2l3.074,15.59a12,12,0,0,1-17.429,12.905l-15.269-8.159a12,12,0,0,0-11.311,0l-15.269,8.159A12,12,0,0,1,31.628,104.36L34.7,88.77a12,12,0,0,0-3.7-11.2L19.352,66.965a12,12,0,0,1,6.625-20.786L42.49,44.164a12,12,0,0,0,9.348-6.683Z' transform='translate(139.962 129.196) rotate(180)' fill='url(%23linear-gradient)'/%3E%3C/svg%3E%0A");
		}

		&.active:before {
			height: 100%;
		}

		&:first-child {
			transform: rotate(150deg);
		}
		&:nth-child(2) {
			transform: rotate(180deg) translateY(35%);
		}
		&:last-child {
			transform: rotate(210deg);
		}
	}
}

.scores {
	.player {
		.prop {
			svg {
				position: absolute;
				top: 0;
				left: 0;
				right: 0;
				bottom: 0;
				height: 150%;
				width: 150%;
				left: -2rem;
				top: 50%;
				transform: translateY(-50%);
			}
		}

		&.player-2 {
			.prop {
				svg {
					left: auto;
					right: -2rem;
				}
			}
		}
	}
}
.pre-end {
	.prop {
		svg {
			height: 50vh;
		}
		&.player-1 {
			svg {
				animation: shake1 1s;
				animation-iteration-count: infinite;
			}
		}
		&.player-2 {
			svg {
				animation: shake2 1s;
				animation-iteration-count: infinite;
			}
		}
		@keyframes shake1 {
			0% {
				transform: translate(0.2rem, 0.2rem) rotate(0deg);
			}
			10% {
				transform: translate(-0.2rem, -0.4rem) rotate(-1deg);
			}
			20% {
				transform: translate(-0.6rem, 0px) rotate(1deg);
			}
			30% {
				transform: translate(0.6rem, 0.4rem) rotate(0deg);
			}
			40% {
				transform: translate(0.2rem, -0.2rem) rotate(1deg);
			}
			50% {
				transform: translate(-0.2rem, 0.4rem) rotate(-1deg);
			}
			60% {
				transform: translate(-0.6rem, 0.2rem) rotate(0deg);
			}
			70% {
				transform: translate(0.6rem, 0.2rem) rotate(-1deg);
			}
			80% {
				transform: translate(-0.2rem, -0.2rem) rotate(1deg);
			}
			90% {
				transform: translate(0.2rem, 0.4rem) rotate(0deg);
			}
			100% {
				transform: translate(0.2rem, -0.4rem) rotate(-1deg);
			}
		}
		@keyframes shake2 {
			0% {
				transform: translate(-0.2rem, 0.2rem) rotate(0deg);
			}
			10% {
				transform: translate(0.2rem, 0.4rem) rotate(-1deg);
			}
			20% {
				transform: translate(0.6rem, 0px) rotate(1deg);
			}
			30% {
				transform: translate(-0.6rem, 0.4rem) rotate(0deg);
			}
			40% {
				transform: translate(-0.4rem, -0.1rem) rotate(1deg);
			}
			50% {
				transform: translate(0.2rem, -0.4rem) rotate(-1deg);
			}
			60% {
				transform: translate(0.6rem, -0.1rem) rotate(0deg);
			}
			70% {
				transform: translate(-0.3rem, -0.2rem) rotate(-1deg);
			}
			80% {
				transform: translate(0.2rem, -0.2rem) rotate(1deg);
			}
			90% {
				transform: translate(-0.2rem, 0.2rem) rotate(0deg);
			}
			100% {
				transform: translate(-0.2rem, -0.2rem) rotate(-1deg);
			}
		}
	}
}
</style>
<style scoped lang="scss">
$border-radius: px(50);

.pre-end {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	opacity: 0;
	transition: all 0.3s;
	&.active {
		opacity: 1;
	}
	.prop {
		z-index: 9999;
		position: fixed;
	}

	&.players-1 {
		.prop.player-1 {
			left: 50%;
			top: 50%;
			transform: translate(-50%, -50%);
		}
		.prop.player-2 {
			display: none;
		}
	}

	&.players-2 {
		.prop.player-1 {
			left: 25%;
			top: 50%;
			transform: translate(-50%, -50%);
		}
		.prop.player-2 {
			right: 25%;
			top: 50%;
			transform: translate(50%, -50%);
		}
	}
}

.the-winner-is {
	color: black;
	text-align: center;
	margin-bottom: 2rem;
	font-size: 2rem;
	span {
		font-weight: bold;
		&.color-orange {
			color: $mondadori-orange;
		}
		&.color-pink {
			color: $mondadori-pink;
		}
	}
}

.end {
	opacity: 0;
	transition: all 0.3s;
	&.active {
		opacity: 1;
	}
}

.scores {
	display: flex;
	justify-content: space-between;
	&.players-1 {
		justify-content: center;
	}
	height: 5rem;
	gap: 2rem;
	margin-top: px(50);

	&.players-1 {
		.player-1 {
			justify-content: center;
		}
	}
	.player {
		background: $mondadori-blue;
		color: $mondadori-yellow;
		position: relative;
		display: flex;
		border-radius: $border-radius;
		width: 50%;

		.value {
			font-size: 3rem;
			line-height: 3rem;
		}

		.guessed-words {
			position: absolute;
			bottom: 0;
			left: 50%;
			transform: translate(-50%, 80%);
			background: $dark-blue;
			padding: 0.5rem 2rem;
			border-radius: $border-radius;
		}

		&.player-2 {
			flex-direction: row-reverse;
			.score {
				text-align: right;
			}
		}
		.prop {
			width: 5rem;
			position: relative;
			svg {
				position: absolute;
				top: 0;
				left: 0;
				right: 0;
				bottom: 0;
				width: 100%;
				height: 100%;
			}
		}
	}
}

.report {
	z-index: 100;
	position: relative;
	background: white;
	padding: px(100);
	border-radius: $border-radius;
	box-shadow: 0 0 10px 4px rgba(0, 0, 0, 0.05);
	margin: px(100) 0;
	margin-top: px(50);

	@include breakpoint(s) {
		padding: px(75) px(25);
	}
	/* 
		.stars {
			display: flex;
			justify-content: center;
			.star {
				display: inline-block;
				position: relative;
				width: px(130);
				height: px(130);
				background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='139.962' height='129.196' viewBox='0 0 139.962 129.196'%3E%3Cdefs%3E%3ClinearGradient id='linear-gradient' x1='0.5' y1='0.5' x2='0.5' y2='1' gradientUnits='objectBoundingBox'%3E%3Cstop offset='0' stop-color='%23bababa'/%3E%3Cstop offset='1' stop-color='%23bababa'/%3E%3C/linearGradient%3E%3C/defs%3E%3Cpath id='Poligono_4' data-name='Poligono 4' d='M59.18,22.314a12,12,0,0,1,21.6,0l7.342,15.167a12,12,0,0,0,9.348,6.683l16.514,2.015a12,12,0,0,1,6.625,20.786l-11.655,10.61a12,12,0,0,0-3.7,11.2l3.074,15.59a12,12,0,0,1-17.429,12.905l-15.269-8.159a12,12,0,0,0-11.311,0l-15.269,8.159A12,12,0,0,1,31.628,104.36L34.7,88.77a12,12,0,0,0-3.7-11.2L19.352,66.965a12,12,0,0,1,6.625-20.786L42.49,44.164a12,12,0,0,0,9.348-6.683Z' transform='translate(139.962 129.196) rotate(180)' fill='url(%23linear-gradient)'/%3E%3C/svg%3E%0A");				background-size: px(130);
				background-repeat: no-repeat;
				background-position: top;
				transform: rotate(180deg);
				background-size: px(150);

				&:before {
					content: '';
					transition: all 1s;
					background-repeat: no-repeat;
					background-position: top;
					position: absolute;
					top: 0;
					left: 0;
					right: 0;
					bottom: 0;
					width: 100%;
					height: 0;
					background-size: px(150);
					background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='139.962' height='129.196' viewBox='0 0 139.962 129.196'%3E%3Cdefs%3E%3ClinearGradient id='linear-gradient' x1='0.5' y1='0.5' x2='0.5' y2='1' gradientUnits='objectBoundingBox'%3E%3Cstop offset='0' stop-color='%23ffe500'/%3E%3Cstop offset='1' stop-color='%23ff9a00'/%3E%3C/linearGradient%3E%3C/defs%3E%3Cpath id='Poligono_5' data-name='Poligono 5' d='M59.18,22.314a12,12,0,0,1,21.6,0l7.342,15.167a12,12,0,0,0,9.348,6.683l16.514,2.015a12,12,0,0,1,6.625,20.786l-11.655,10.61a12,12,0,0,0-3.7,11.2l3.074,15.59a12,12,0,0,1-17.429,12.905l-15.269-8.159a12,12,0,0,0-11.311,0l-15.269,8.159A12,12,0,0,1,31.628,104.36L34.7,88.77a12,12,0,0,0-3.7-11.2L19.352,66.965a12,12,0,0,1,6.625-20.786L42.49,44.164a12,12,0,0,0,9.348-6.683Z' transform='translate(139.962 129.196) rotate(180)' fill='url(%23linear-gradient)'/%3E%3C/svg%3E%0A");				}

				&.active:before  {
					height: 100%;
				}

				&:first-child {
					transform: rotate(150deg);
				}
				&:nth-child(2) {
					transform: rotate(180deg) translateY(35%);
				}
				&:last-child {
					transform: rotate(210deg);
				}

			}
		}
 */

	.label-title {
		width: 100%;
		display: block;
		text-align: center;
		text-transform: uppercase;
		color: $mondadori-green;
		font-size: px(20);
	}

	.guessed-words {
		background: $mondadori-green;
		color: white;
		display: inline-block;
		margin: auto;
		left: 50%;
		transform: translateX(-50%);
		position: relative;
		padding: px(10);
		padding-left: px(25);
		padding-right: px(25);
		border-radius: px(25);
		margin-bottom: px(25);
	}

	.single-result {
		box-shadow: 0 0 14px -1px rgba(0, 0, 0, 0.05);
		border-radius: $border-radius;
		padding: px(50);
		margin-bottom: px(25);
		@include breakpoint(s) {
			padding: px(25);
		}

		&.win {
			background: #e3facc;
			color: #1d9c62;
			.word span {
				box-shadow: 0 3px 7px 3px #144a3224;
			}
		}
		&.lost {
			background: #ffeaea;
			color: #fd0510;
			.word span {
				box-shadow: 0 3px 7px 3px #3a15171f;
			}
		}
		.type {
			text-transform: uppercase;
		}
		.word {
			margin-bottom: px(25);

			span {
				display: inline-flex;
				justify-content: center;
				align-items: center;
				height: px(70);
				width: px(70);
				background: #fff;
				border-radius: px(15);
				font-size: px(50);
				text-transform: uppercase;
				margin-right: px(10);
				font-weight: normal;
				@include breakpoint(s) {
					width: px(40);
					height: px(60);
					font-size: px(40);
					margin-right: px(7);
				}
			}
		}
	}
	.buttons {
		display: flex;
		justify-content: center;
		margin: px(50) 0;
		gap: px(25);

		div {
			cursor: pointer;
			font-size: px(25);
			border-radius: 10px;
			height: 5px;
		}

		div:first-child {
			color: $mondadori-orange;
			box-shadow: 0 35px 0 0 $mondadori-orange;
		}

		div:last-child {
			color: $mondadori-green;
			box-shadow: 0 35px 0 0 $mondadori-green;
		}
	}
}
</style>
